"use client";

import { usePathname } from "@/i18n/navigation";

// Sections that render their own full-height app shell (left sidebar + content)
// instead of the marketing top-navbar + footer chrome.
const BARE_SECTIONS = /^\/(?:az\/)?(?:turnuva|takim)(?:\/|$)/;

export function AppFrame({
    navbar,
    footer,
    children,
}: {
    navbar: React.ReactNode;
    footer: React.ReactNode;
    children: React.ReactNode;
}) {
    const pathname = usePathname() ?? "";
    if (BARE_SECTIONS.test(pathname)) {
        return <div className="min-h-dvh">{children}</div>;
    }
    return (
        <div className="bg-primary/5 flex min-h-dvh flex-col overflow-x-clip">
            {navbar}
            <main className="mx-auto flex w-full max-w-380 flex-1 flex-col px-4 py-6 sm:px-6 sm:py-8 lg:px-8">
                {children}
            </main>
            {footer}
        </div>
    );
}
